import React from 'react';
import InvestorDashboardPage from './investorDashboard';

function ClientDashboard(props) {
  return (
    <>
      <InvestorDashboardPage />
    </>
  );
}

ClientDashboard.propTypes = {};

export default ClientDashboard;
